import { render, staticRenderFns } from "./KDZoneMap.vue?vue&type=template&id=0a4c6483&"
import script from "./KDZoneMap.vue?vue&type=script&lang=js&"
export * from "./KDZoneMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports